module.exports = __webpack_public_path__ + "static/img/basestation.c0e7463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/basestation.png
// module id = cMaE
// module chunks = 1